import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

// Step indicator: compact dots + "Step X / N" + current step title.
export function StepIndicator({ steps, current, onJump }) {
  return (
    <div className="space-y-3" data-testid="wizard-step-indicator">
      <div className="flex items-center justify-between">
        <div className="promo-overline">{steps[current]?.label}</div>
        <div className="text-xs tabular-nums text-muted-foreground">
          Step {current + 1} / {steps.length}
        </div>
      </div>
      <div className="flex items-center gap-1.5">
        {steps.map((s, i) => {
          const done = i < current;
          const active = i === current;
          return (
            <button
              key={s.key}
              type="button"
              disabled={i > current}
              onClick={() => i <= current && onJump(i)}
              title={s.label}
              className={cn(
                "h-1.5 flex-1 rounded-full transition-colors",
                active ? "bg-brand" : done ? "bg-brand/40" : "bg-border",
                i <= current && "cursor-pointer",
              )}
              data-testid={`wizard-dot-${i}`}
            >
              {active && (
                <motion.span layoutId="wizard-active" className="block h-full w-full rounded-full bg-brand" />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
